import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, Input } from '@angular/core';
import { Mercaderia, DetalleVenta } from 'src/app/model/index.model';
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';
import { CbMercaderia2Component } from '../../combo/cb-mercaderia-2/cb-mercaderia-2.component';
import { DetalleVentaService, WorkshoppingService } from 'src/app/service/index.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-detalle-venta',
  templateUrl: './detalle-venta.component.html',
  styleUrls: ['./detalle-venta.component.css']
})
export class DetalleVentaComponent implements OnInit {

  contado: 'contado' | 'debito' | 'tarjeta' | 'mayorista' = 'tarjeta'
  contados: string[] = ['tarjeta', 'contado', 'mayorista']

  @ViewChild(CbMercaderia2Component) gr: CbMercaderia2Component;

  @ViewChild("cant", { static: false }) cant: ElementRef;
  @ViewChild("pre", { static: false }) prec: ElementRef;

  @Output() compra = new EventEmitter<DetalleVenta[]>();
  @Output() condicion = new EventEmitter<string>();

  @Input()
  set items(event: DetalleVenta[]) {
    if (event) {
      this.detalle = event;
    }
  }

  cantidad: number = 0;
  precio: number = 0;
  mercaderia: Mercaderia;
  detalle: DetalleVenta[];

  constructor(
    private wsdldi: DetalleVentaService,
    private wsdl: WorkshoppingService) {
    this.detalle = [];
    this.cantidad = 1;
  }

  async ngOnInit() {
    await this.wsdl.registrarCliente()
    await this.wsdl.cargarCarrito();
    this.detalle = [...this.wsdl.detalle];
    this.contado = this.wsdl.condicionVenta
    this.compra.emit(this.detalle)
    this.condicion.emit(this.contado);

  }

  itemSel(event: Mercaderia) {
    this.mercaderia = event
    // this.addRow()
  }

  pase() {
    this.prec.nativeElement.focus()
  }

  async addRow() {
    if (!this.mercaderia || this.cantidad <= 0) {
      UturuncoUtils.showToas('Seleccione un producto y cantidad válida', 'error');
      return;
    }

    // Pasamos la cantidad completa de una vez
    this.wsdl.cantidad = this.cantidad;          // importante: setear antes
    await this.wsdl.itemSel(this.mercaderia);           // una sola llamada

    this.detalle = [...this.wsdl.detalle];        // nueva referencia
    console.log("carrito actualizado", this.detalle);

    this.compra.emit(this.detalle);
    this.condicion.emit(this.contado);

    // Limpiar
    this.mercaderia = new Mercaderia();
    this.cantidad = 1;
    this.gr.foco(true);
  }

  async remove(det: DetalleVenta) {
    if (det.id > 0) {
      await this.wsdldi.doDelete(det.id).then();
    }
    this.wsdl.eliminarDelCarrito(det.mercaderia);
    this.detalle = this.wsdl.detalle;
    this.compra.emit(this.detalle)

  }

  actualizarPrecio(cond: 'contado' | 'tarjeta' | 'mayorista') {
    this.wsdl.actualizarCarritoPorCondicion(cond);
    this.detalle = [...this.wsdl.detalle];
    this.compra.emit(this.detalle)
  }

  get total(): number {
    return this.wsdl.calculateTotal();
  }
}